<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="900px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Exportar Aula Polivalência</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="gestaoDeAula">
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(enableSubmit)">
                <div>
                  <v-col class="pt-4 pb-0" cols="12">
                    <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Turma</e-label>
                      <p class="font-weight-regular">
                        <v-select
                          :items="turmas"
                          item-text="turma.descricao"
                          item-value="turma.id"
                          :hint="`${turmaSelecionada?.turma?.franquia?.descricao || ''}`"
                          return-object
                          label="Selecione o campo abaixo"
                          v-model="turmaSelecionada"
                          :error-messages="errors"
                        ></v-select>
                      </p>
                    </ValidationProvider>
                  </v-col>

                  <v-col class="pt-4 pb-0" cols="6">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.tipo_de_aula }}
                    </p>
                  </v-col>

                  <!-- NOVO V-ROW PARA AGRUPAR DATA E HORÁRIOS POR DISCIPLINA -->
                  <v-row class="pt-5 pb-0">
                    <v-col class="pt-0 pb-0" cols="6">
                      <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                        <v-dialog
                          ref="dateDialog"
                          v-model="modal"
                          :return-value.sync="dataAulaDuplicada"
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <e-label>Selecione uma data</e-label>
                            <v-text-field
                              dense
                              solo
                              v-model="data_aula"
                              label="Data"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :error-messages="errors"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            color="primary"
                            v-model="dataAulaDuplicada"
                            scrollable
                            :allowed-dates="allowedDates"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dateDialog.save(dataAulaDuplicada)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </ValidationProvider>
                    </v-col>

                    <!-- CAMPOS DE HORÁRIO PARA CADA DISCIPLINA -->
                    <template v-for="(disc, index) in gestaoDeAula.disciplinas_com_descricao || []">
                      <v-col class="pt-0 pb-0" cols="6" :key="`horario-${index}`">
                        <e-label>Selecione um horário - {{ disc.descricao }}</e-label>
                        <e-autocomplete
                          :items="disciplinaHorarios[disc.id]"
                          :value="horarios_selecionados_extras[index]"
                          @change="atualizarHorarios($event, index)"
                          clearable
                          outlined
                          label="Selecione o horário"
                          item-text="descricao"
                          item-value="id"
                          return-object
                          dense
                        />
                      </v-col>
                    </template>
                  </v-row>

                  <!-- REMOVA O V-ROW ANTERIOR QUE CONTINHA O LOOP DE DISCIPLINAS OU MOVA ELE PARA DEPOIS -->
                </div>
                <div class="mt-4 mb-2">
                  <e-label class="font-weight-medium"
                    >Planejamento e Horários por Disciplina</e-label
                  >
                  <e-help-tooltip :text="$constants.tooltips.aulas.exportarAulaPolivalente" />
                </div>
                <v-alert v-show="messageAlert" dense outlined type="warning" class="mb-4">
                  {{ messageAlert }}
                </v-alert>
                <v-row dense>
                  <v-col
                    v-for="(disc, index) in gestaoDeAula.disciplinas_com_descricao || []"
                    :key="index"
                    cols="12"
                  >
                    <v-card outlined class="pa-4 rounded-lg mb-4">
                      <h3 class="text-primary mb-4">
                        {{ disc.descricao }}
                      </h3>
                      <v-row>
                        <v-col cols="12">
                          <v-card flat class="pa-4 grey lighten-4 rounded">
                            <!-- <div class="mb-3">
                              <label class="info-label">Conteúdo:</label>
                              <p class="text-body-2 mb-0">{{ JSON.parse(gestaoDeAula.conteudo_polivalencia || '[]')[index] || '-' }}</p>
                            </div> -->

                            <div class="mb-3">
                              <label class="info-label font-weight-bold">Unidades Temáticas:</label>
                              <p class="text-body-2 mb-0">
                                {{ parseJsonArray(gestaoDeAula.unidades_tematicas)[index] || "-" }}
                              </p>
                            </div>

                            <div class="mb-3">
                              <label class="info-label font-weight-bold"
                                >Objetos do Conhecimento:</label
                              >
                              <p class="text-body-2 mb-0">
                                {{ parseJsonArray(gestaoDeAula.objeto_conhecimento)[index] || "-" }}
                              </p>
                            </div>

                            <div class="mb-3">
                              <label class="info-label font-weight-bold">Habilidades:</label>
                              <p class="text-body-2 mb-0">
                                {{ parseJsonArray(gestaoDeAula.habilidades)[index] || "-" }}
                              </p>
                            </div>

                            <div class="mb-3">
                              <label class="info-label font-weight-bold"
                                >Objetivo de Aprendizagem:</label
                              >
                              <p class="text-body-2 mb-0">
                                {{
                                  parseJsonArray(gestaoDeAula.objetivo_de_aprendizagem)[index] ||
                                  "-"
                                }}
                              </p>
                            </div>

                            <div class="mb-3">
                              <label class="info-label font-weight-bold"
                                >Procedimentos Metodológicos:</label
                              >
                              <p class="text-body-2 mb-0">
                                {{
                                  parseJsonArray(gestaoDeAula.procedimentos_metodologicos)[index] ||
                                  "-"
                                }}
                              </p>
                            </div>

                            <div>
                              <label class="info-label font-weight-bold">Material de Apoio:</label>
                              <p class="text-body-2 mb-0">
                                {{ parseJsonArray(gestaoDeAula.material_de_apoio)[index] || "-" }}
                              </p>
                            </div>
                          </v-card>
                        </v-col>

                        <!-- <v-col cols="12" md="6">
                          <e-label>Selecione um horário</e-label>
                          <e-autocomplete
                            :items="
                              disciplinaHorarios[gestaoDeAula.disciplinas_com_descricao[index].id]
                            "
                            :value="horarios_selecionados_extras[index]"
                            @change="atualizarHorarios($event, index)"
                            clearable
                            outlined
                            label="Selecione o horário"
                            item-text="descricao"
                            item-value="id"
                            return-object
                            dense
                          />
                        </v-col> -->
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>

                <v-card outlined class="pa-4 rounded-lg mb-4">
                  <v-card flat class="pa-4 grey lighten-4 rounded">
                    <v-col cols="12" class="mt-2">
                      <e-label class="font-weight-medium">Avaliação da Aula</e-label>
                      <p class="font-weight-regular">
                        {{ gestaoDeAula.avaliacao_da_aula || "-" }}
                      </p>
                    </v-col>
                  </v-card>
                </v-card>

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false)"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    @click="handleSubmit(enableSubmit)"
                    :disabled="!totalmentePreenchido || temConflito || horariosDuplicados"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="exportarAula"
    >
    </e-modal-confirm>
    <aulas-em-conflitos v-model="sheetAulasEmConflito" :aulas="aulasEmConflito" />
  </v-row>
</template>

<script>
import AulasEmConflitos from "@/components/Aulas/AulasEmConflitos.vue";

export default {
  components: {
    AulasEmConflitos,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      gestoesFiltradas: [],
      dataAulaDuplicada: null,
      modal: false,
      menu: false,
      gestaoDeAula: {},
      data_aula: null,
      confirmDialog: false,
      turmas: [],
      turmaSelecionada: {
        turma: {
          id: null,
          franquia: {
            descricao: "",
            fantasia: "",
          },
        },
      },
      aulasEmConflito: [],
      sheetAulasEmConflito: false,
      temConflito: false,
      messageAlert: null,
      objectModal: {
        title: "Exportar aula",
        message: "Tem certeza que deseja exportar esta aula?",
      },

      horarios: [],
      date: null,
      // horarioSelecionado: null,
      horariosFiltrados: [],
      horarioSelecionado: null,
      horarios_selecionados_extras: [],
      itemsEsperados: [
        { label: "Turma", value: "turmaSelecionada" },
        { label: "Data", value: "dataAulaDuplicada" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
      todosHorariosDisponiveis: [],
      disciplinaHorarios: {},
    };
  },
  created() {
    this.$watch("turmaSelecionada", async (val) => {
      const shouldAdd = !!(val && val.turma && val.turma.id);
      this.$toggleItemPreenchidoBarraProgresso(
        "turmaSelecionada",
        shouldAdd,
        this.itemsPreenchidos
      );
      if (val && val.turma && val.turma.id) {
        await this.carregarTodosHorariosDisciplinasExport();
      }
    });

    this.$watch("dataAulaDuplicada", async (val) => {
      this.$toggleItemPreenchidoBarraProgresso("dataAulaDuplicada", !!val, this.itemsPreenchidos);
      if (val) {
        const date = new Date(val);
        const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
        this.data_aula = data_old.replaceAll("/", "/");
        await this.carregarTodosHorariosDisciplinasExport();
      }
    });

    this.$watch(
      "form",
      (val) => {
        if (val && val.disciplinas_com_descricao && val.disciplinas_com_descricao.length > 0) {
          this.itemsEsperados = this.itemsEsperados.filter(
            (item) => !item.value.startsWith("horarios_selecionados_extras")
          );

          val.disciplinas_com_descricao.forEach((disc, index) => {
            const horarioItem = {
              label: `Horário - ${disc.descricao}`,
              value: `horarios_selecionados_extras[${index}]`,
              index,
            };

            this.itemsEsperados.push(horarioItem);

            this.$watch(`horarios_selecionados_extras.${index}`, (val) => {
              this.$toggleItemPreenchidoBarraProgresso(
                horarioItem.value,
                !!val,
                this.itemsPreenchidos
              );
            });
          });
        }
      },
      { immediate: true }
    );
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.gestaoDeAula = val;
      },
    },
    turmaSelecionada: {
      immediate: true,
      handler(val) {
        this.horarios = val?.turma?.horarios || [];
      },
    },
    horarios_selecionados_extras: {
      deep: true,
      handler(newVal) {
        this.verificarConflitoAula();
      },
    },
    dialog: {
      async handler(val) {
        if (val) {
          this.$loaderService.open("Carregando gestões de aula");
          try {
            const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
              this.gestaoDeAula
            );

            this.gestoesFiltradas = gestoes.filter(
              (gestao) => gestao.turma_id !== this.gestaoDeAula.turma_id
            );

            this.turmas = gestoes.filter((gestao) => {
              return (
                gestao.turma && gestao.turma.id && gestao.relacoesDiasHorarios && gestao.disciplinas
              );
            });
          } catch (error) {
            this.$handleError(error);
          } finally {
            this.$loaderService.close();
            await this.carregarTodosHorariosDisciplinasExport();
          }
        } else {
          // Limpa os estados quando o modal é fechado
          this.dataAulaDuplicada = null;
          this.data_aula = null;
          this.horarios_selecionados_extras = [];
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
          this.messageAlert = null;
          this.turmaSelecionada = {
            turma: {
              id: null,
              franquia: {
                descricao: "",
                fantasia: "",
              },
            },
          };
        }
      },
    },
  },
  computed: {
    horariosTotalmenteSelecionados() {
      const disciplinasOriginaisCount = this.gestaoDeAula.disciplinas_com_descricao?.length || 0;
      let preenchidosCount = 0;

      for (let i = 0; i < disciplinasOriginaisCount; i++) {
        const selecaoAtual = this.horarios_selecionados_extras[i];
        if (selecaoAtual) {
          preenchidosCount++;
        }
      }

      const resultado = preenchidosCount >= disciplinasOriginaisCount;

      return resultado;
    },
    conteudosPolivalencia() {
      return this.gestaoDeAula?.disciplinas_com_descricao || [];
    },
    horariosDuplicados() {
      const ids = (this.horarios_selecionados_extras || [])
        .flat()
        .filter(Boolean)
        .map((h) => Number(h.id ?? h));

      const unique = new Set(ids);

      return ids.length !== unique.size;
    },
  },
  methods: {
    parseJsonArray(value) {
      if (!value) return [];
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [value];
      }
    },
    async verificarConflitoAula() {
      if (!this.dataAulaDuplicada) {
        return;
      }
      if (!this.turmaSelecionada?.turma?.id) {
        return;
      }

      try {
        const turma_id = this.turmaSelecionada.turma.id;

        const horarios = (this.horarios_selecionados_extras || [])
          .flat()
          .filter(Boolean)
          .map((h) => Number(h.id ?? h));

        if (!horarios.length) {
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
          return;
        }

        const respostas = await Promise.all(
          horarios.map((horario) =>
            this.$services.aulasService.pesquisarAulasEmConflitosPoli(
              this.dataAulaDuplicada,
              horario,
              turma_id,
              null
            )
          )
        );

        const conflitos = respostas
          .filter((response) => response.data.conflito)
          .flatMap((response) =>
            (response.data.aulas || []).map((conflito) => ({
              id: conflito.id,
              professor: { nome: conflito.instrutor },
              situacao: conflito.situacao || "Aguardando",
              data: this.dataAulaDuplicada,
              turma: {
                descricao: conflito.turma,
                franquia: { descricao: conflito.franquia },
              },
              disciplina: { descricao: conflito.disciplina_descricao },
              horario: conflito.horario,
            }))
          );

        if (conflitos.length) {
          this.aulasEmConflito = conflitos;
          this.sheetAulasEmConflito = true;
          this.temConflito = true;
          this.messageAlert =
            "Já existe aula registrada nessa data com esses mesmos horários, selecione uma outra data ou horário!";
        } else {
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
          this.messageAlert = null;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    toYMD(v) {
      if (!v) return "";

      if (typeof v === "string") {
        if (/^\d{4}-\d{2}-\d{2}/.test(v)) {
          return v.slice(0, 10);
        }

        const parts = v.split("/");
        if (parts.length === 3) {
          const [dia, mes, ano] = parts;
          return `${ano}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
        }

        if (v.length > 10) return v.slice(0, 10);
      }

      const d = v instanceof Date ? v : new Date(v);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")}`;
    },

    async buscarTodosHorarios() {
      try {
        const response = await this.$services.gestoesDeAulasService.getAllHorarios();
        const horariosData = response.data || response;
        this.todosHorariosDisponiveis = horariosData.map((h) => ({
          id: h.id,
          turno_id: h.turno_id,
          descricao: h.descricao || "Horário",
          final: h.final,
          inicio: h.inicio,
        }));

        return this.todosHorariosDisponiveis;
      } catch (error) {
        this.$handleError(error);
        return [];
      }
    },

    atualizarHorarios(novoValor, index) {
      this.$set(this.horarios_selecionados_extras, index, novoValor);
    },

    async getFilteredHorariosByDisciplineExport(disciplineIdOriginal) {
      if (
        !this.data_aula ||
        !this.turmaSelecionada?.relacoesDiasHorarios ||
        !this.turmaSelecionada?.disciplinas
      ) {
        return [];
      }

      const diaDaSemana = new Date(this.toYMD(this.data_aula)).getDay();

      const disciplinaOriginal = this.gestaoDeAula.disciplinas_com_descricao.find(
        (d) => d.id === disciplineIdOriginal
      );
      if (!disciplinaOriginal) return [];

      const disciplinaDestino = this.turmaSelecionada.disciplinas.find(
        (d) => d.descricao === disciplinaOriginal.descricao
      );
      if (!disciplinaDestino) {
        return [];
      }

      const filteredRelations = this.turmaSelecionada.relacoesDiasHorarios.filter(
        (r) => r.dia.id === diaDaSemana && r.disciplina.id === disciplinaDestino.id
      );

      const horariosFiltrados = filteredRelations.map((r) => r.horario);

      return horariosFiltrados;
    },

    async carregarHorariosDisciplinaExport(disciplineIdOriginal) {
      this.$set(
        this.disciplinaHorarios,
        disciplineIdOriginal,
        await this.getFilteredHorariosByDisciplineExport(disciplineIdOriginal)
      );
    },

    async carregarTodosHorariosDisciplinasExport() {
      if (
        this.gestaoDeAula &&
        this.gestaoDeAula.disciplinas_com_descricao &&
        this.turmaSelecionada?.turma?.id
      ) {
        const disciplinasOriginaisCount = this.gestaoDeAula.disciplinas_com_descricao?.length || 0;

        if (
          !Array.isArray(this.horarios_selecionados_extras) ||
          this.horarios_selecionados_extras.length !== disciplinasOriginaisCount
        ) {
          this.horarios_selecionados_extras = Array(disciplinasOriginaisCount).fill(null);
        }

        await Promise.all(
          this.gestaoDeAula.disciplinas_com_descricao.map((discOriginal) =>
            this.carregarHorariosDisciplinaExport(discOriginal.id)
          )
        );
      }
    },

    allowedDates(date) {
      if (!this.turmaSelecionada || !this.turmaSelecionada.relacoesDiasHorarios) {
        return false;
      }

      const dayOfWeek = new Date(date).getDay();

      const diasPermitidos = this.turmaSelecionada.relacoesDiasHorarios.map((rel) => rel.dia.id);

      return diasPermitidos.includes(dayOfWeek);
    },
    enableSubmit() {
      if (!this.turmaSelecionada.turma.id) {
        this.$toast.danger("Por favor, selecione uma turma");
        return;
      }

      if (!this.dataAulaDuplicada) {
        this.$toast.danger("Por favor, selecione uma data");
        return;
      }

      if (
        this.gestaoDeAula.tipo_de_aula !== "Aula Remota" &&
        !this.horariosTotalmenteSelecionados
      ) {
        this.$toast.danger("Por favor, selecione um horário para cada componente curricular");
        return;
      }

      this.confirmDialog = !this.confirmDialog;
      this.gestaoDeAula.data = this.dataAulaDuplicada;
    },
    async exportarAula() {
      this.$loaderService.open("Exportando a Aula");
      try {
        this.gestaoDeAula.horarios_extras = await this.getHorariosExtras();

        this.gestaoDeAula.instrutorDisciplinaTurma_id = parseInt(this.turmaSelecionada.id, 10);
        this.gestaoDeAula.turma_id = this.turmaSelecionada.turma.id;
        this.confirmDialog = !this.confirmDialog;

        this.$emit("dialogChange", false);
        await this.$services.aulasService.criar(this.gestaoDeAula);

        this.$toast.success("Aula exportada com sucesso!");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async getHorariosExtras() {
      const disciplinasOriginais = this.gestaoDeAula.disciplinas_com_descricao;
      const horarios_selecionados_extras = this.horarios_selecionados_extras || [];

      const horariosMapeados = disciplinasOriginais
        .map((discOriginal, idx) => {
          const item = horarios_selecionados_extras[idx];

          const array = item ? [item.id] : [];

          const disciplinaDestino = this.turmaSelecionada.disciplinas.find(
            (d) => d.descricao === discOriginal.descricao
          );

          return { id: disciplinaDestino ? disciplinaDestino.id : null, array };
        })
        .filter((item) => item.id !== null);

      return JSON.stringify(horariosMapeados);
    },
  },
  mounted() {
    this.buscarTodosHorarios();
    this.carregarTodosHorariosDisciplinasExport();
  },
};
</script>
